module.exports = __webpack_public_path__ + "img/fallback_drug_picture.47ef4815.png";